"use strict";
(() => {
  // .src/js/bk-media.js
  var VideoProof = class extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector(".video-proof-content");
      this.video = this.querySelector(".video-proof-content video");
      this.html = document.querySelector("html");
      this.visible = false;
      this.eventListener();
    }
    handlePopoverToggle(e) {
      if (e.newState === "open") {
        this.video.play();
        this.html.classList.add("overflow-hidden");
      } else {
        this.video.pause();
        this.html.classList.remove("overflow-hidden");
      }
    }
    eventListener() {
      this.content.addEventListener("toggle", this.handlePopoverToggle.bind(this));
    }
  };
  customElements.define("video-proof", VideoProof);

  function updateMainPriceBadge() {
    const priceBadgeEl = document.getElementById('boomers-main-price-badge');
    if (!priceBadgeEl) return;
    
    const priceDisplay = document.querySelector('.boomers-price-display');
    if (!priceDisplay) {
      priceBadgeEl.style.display = 'none';
      return;
    }
    
    const currentVariantId = priceDisplay.dataset.currentVariantId;
    let variantTassen = {};
    
    try {
      variantTassen = JSON.parse(priceDisplay.dataset.variantTassen || '{}');
    } catch (e) {
      console.error('Error parsing variant tassen:', e);
      priceBadgeEl.style.display = 'none';
      return;
    }
    
    const tassen = variantTassen[currentVariantId];
    
    const priceEl = document.querySelector('.boomers-total-discount-price');
    if (!priceEl) {
      priceBadgeEl.style.display = 'none';
      return;
    }
    
    let priceText = priceEl.textContent.trim();
    priceText = priceText.replace('€', '').replace(',', '.').trim();
    const price = parseFloat(priceText);
    
    if (tassen && tassen > 0 && price && price > 0) {
      const pricePerCup = price / tassen;
      const formattedPrice = pricePerCup.toFixed(2).replace('.', ',');
      priceBadgeEl.textContent = formattedPrice + '€ / Tasse';
      priceBadgeEl.style.display = 'inline-block';
    } else {
      priceBadgeEl.style.display = 'none';
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    updateMainPriceBadge();
    
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        const priceDisplay = document.querySelector('.boomers-price-display');
        if (priceDisplay) {
          priceDisplay.dataset.currentVariantId = event.detail.variant.id;
        }
        setTimeout(updateMainPriceBadge, 100);
      }
    });
    
    const observer = new MutationObserver(function(mutations) {
      updateMainPriceBadge();
    });
    
    const priceEl = document.querySelector('.boomers-total-discount-price');
    if (priceEl) {
      observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  });

  // Close quickbuy popup when cart drawer opens
  document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.getElementById('cart-drawer');
    
    if (cartDrawer) {
      // Listen for cart drawer opening using the correct event
      cartDrawer.addEventListener('dialog:after-show', function() {
        // Close all open quickbuy drawers
        const quickBuyDrawers = document.querySelectorAll('quick-buy-drawer[open]');
        quickBuyDrawers.forEach(function(drawer) {
          drawer.hide();
        });
      });
    }
  });

  // ========================================
  // PRODUCT CARD VARIANT SELECTION TRACKING
  // ========================================
  
  // Track selected variants in product cards
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for variant selection changes in product cards
    document.addEventListener('change', function(event) {
      const target = event.target;
      
      // Check if this is a variant selection in a product card
      if (target.matches('input[type="radio"][name*="swatch-"][data-variant-id]')) {
        const productCard = target.closest('.product-card');
        if (productCard) {
          const selectedVariantId = target.dataset.variantId;
          const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
          
          if (quickBuyDrawer && selectedVariantId) {
            // Store the selected variant ID in the quick buy drawer
            quickBuyDrawer.setAttribute('data-selected-variant-id', selectedVariantId);
            
            // Update the handle attribute to include the selected variant
            const currentHandle = quickBuyDrawer.getAttribute('handle');
            const baseHandle = currentHandle.split('?')[0];
            quickBuyDrawer.setAttribute('handle', `${baseHandle}?variant=${selectedVariantId}`);
            
            // If the drawer is already open, update its content
            if (quickBuyDrawer.hasAttribute('open')) {
              // Force reload the drawer content with the new variant
              quickBuyDrawer._hasLoaded = false;
              quickBuyDrawer.show();
            }
          }
        }
      }
    });
    
    // Listen for clicks on variant labels in product cards
    document.addEventListener('click', function(event) {
      const target = event.target;
      
      // Check if this is a click on a variant label in a product card
      if (target.matches('.product-card__variant-list label, .product-card__variant-list .thumbnail-swatch, .product-card__variant-list .block-swatch, .product-card__variant-list .color-swatch')) {
        const productCard = target.closest('.product-card');
        if (productCard) {
          // Use a small delay to allow the radio input to be updated
          setTimeout(function() {
            // Find the associated radio input
            const radioInput = productCard.querySelector('input[type="radio"][name*="swatch-"][data-variant-id]:checked');
            if (radioInput) {
              const selectedVariantId = radioInput.dataset.variantId;
              const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
              let price_cont=productCard.querySelector(".price-value-wrap");
              if (radioInput.dataset.price&&price_cont){
                price_cont.innerText=radioInput.dataset.price;
              }
              updateQuickBuyDrawer(productCard, selectedVariantId);
            }
          }, 50);
        }
      }
    });
    
    // Use mutation observer to detect variant selection changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
          const target = mutation.target;
          if (target.matches('input[type="radio"][name*="swatch-"][data-variant-id]') && target.checked) {
            const productCard = target.closest('.product-card');
            if (productCard) {
              const selectedVariantId = target.dataset.variantId;
              const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
              
              updateQuickBuyDrawer(productCard, selectedVariantId);
            }
          }
        }
      });
    });
    
    // Start observing all product cards for variant changes
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function(card) {
      const variantInputs = card.querySelectorAll('input[type="radio"][name*="swatch-"][data-variant-id]');
      variantInputs.forEach(function(input) {
        observer.observe(input, { attributes: true, attributeFilter: ['checked'] });
      });
    });
    
    // Listen for quick buy drawer opening to ensure correct variant is selected
    document.addEventListener('dialog:after-show', function(event) {
      const drawer = event.target;
      if (drawer.tagName === 'QUICK-BUY-DRAWER') {
        const selectedVariantId = drawer.getAttribute('data-selected-variant-id');
        if (selectedVariantId) {
          console.log('BK-Media: Quick buy drawer opened, selecting variant:', selectedVariantId);
          
          // Function to select the variant with multiple attempts
          function selectVariant() {
            const variantInputs = drawer.querySelectorAll('input[type="radio"][data-variant-id]');
            let variantSelected = false;
            
            variantInputs.forEach(function(input) {
              if (input.dataset.variantId === selectedVariantId) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                variantSelected = true;
                console.log('BK-Media: Variant selected in quick buy drawer:', selectedVariantId);
              }
            });
            
            // If variant not found, try again after a short delay
            if (!variantSelected && variantInputs.length === 0) {
              setTimeout(selectVariant, 100);
            }
          }
          
          // Try to select the variant immediately and with delays
          selectVariant();
          setTimeout(selectVariant, 200);
          setTimeout(selectVariant, 500);
        }
      }
    });
    
    // Listen for quick buy drawer closing to reset state
    document.addEventListener('dialog:after-hide', function(event) {
      const drawer = event.target;
      if (drawer.tagName === 'QUICK-BUY-DRAWER') {
        console.log('BK-Media: Quick buy drawer closed, resetting state');
        // Clear the loaded state to ensure fresh content on next open
        drawer._hasLoaded = false;
      }
    });
    
    // Also listen for the variant:change event to update the quick buy drawer
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        const productCard = event.target.closest('.product-card');
        if (productCard) {
          const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
          if (quickBuyDrawer) {
            const selectedVariantId = event.detail.variant.id.toString();
            quickBuyDrawer.setAttribute('data-selected-variant-id', selectedVariantId);
            
            // Update the handle attribute
            const currentHandle = quickBuyDrawer.getAttribute('handle');
            const baseHandle = currentHandle.split('?')[0];
            quickBuyDrawer.setAttribute('handle', `${baseHandle}?variant=${selectedVariantId}`);
          }
        }
      }
    });
    
    // Handle dynamic content loading (for AJAX-loaded product cards)
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      const productCards = section.querySelectorAll('.product-card');
      productCards.forEach(function(card) {
        const variantInputs = card.querySelectorAll('input[type="radio"][name*="swatch-"][data-variant-id]');
        variantInputs.forEach(function(input) {
          observer.observe(input, { attributes: true, attributeFilter: ['checked'] });
        });
      });
    });
    
    // Function to update quick buy drawer with selected variant
    function updateQuickBuyDrawer(productCard, selectedVariantId) {
      const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
      if (quickBuyDrawer && selectedVariantId) {
        console.log('BK-Media: Updating quick buy drawer with variant ID:', selectedVariantId);
        
        // Store the selected variant ID in the quick buy drawer
        quickBuyDrawer.setAttribute('data-selected-variant-id', selectedVariantId);
        
        // Update the handle attribute to include the selected variant
        const currentHandle = quickBuyDrawer.getAttribute('handle');
        const baseHandle = currentHandle.split('?')[0];
        quickBuyDrawer.setAttribute('handle', `${baseHandle}?variant=${selectedVariantId}`);
        
        // Always force reload the drawer content when variant changes
        // This ensures the drawer shows the correct variant even if it was previously loaded
        quickBuyDrawer._hasLoaded = false;
        
        // If the drawer is already open, reload it immediately
        if (quickBuyDrawer.hasAttribute('open')) {
          quickBuyDrawer.show();
        }
      }
    }
    
    // Additional listener for when quick buy drawer content is loaded
    document.addEventListener('DOMContentLoaded', function() {
      // Override the QuickBuyDrawer's show method to ensure variant selection
      const originalQuickBuyDrawer = customElements.get('quick-buy-drawer');
      if (originalQuickBuyDrawer) {
        const originalShow = originalQuickBuyDrawer.prototype.show;
        originalQuickBuyDrawer.prototype.show = function() {
          const result = originalShow.call(this);
          
          // After the drawer is shown, ensure the correct variant is selected
          if (this.hasAttribute('data-selected-variant-id')) {
            const selectedVariantId = this.getAttribute('data-selected-variant-id');
            
            // Use a more robust approach to wait for content to be loaded
            const checkAndSelectVariant = () => {
              const variantInputs = this.querySelectorAll('input[type="radio"][data-variant-id]');
              if (variantInputs.length > 0) {
                variantInputs.forEach(function(input) {
                  if (input.dataset.variantId === selectedVariantId) {
                    input.checked = true;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                    console.log('BK-Media: Variant selected after drawer content loaded:', selectedVariantId);
                  }
                });
              } else {
                // Content not loaded yet, try again
                setTimeout(checkAndSelectVariant, 100);
              }
            };
            
            // Start checking after a short delay
            setTimeout(checkAndSelectVariant, 100);
          }
          
          return result;
        };
      }
    });
    
    // Also ensure variant selection works when the drawer is first opened
    document.addEventListener('DOMContentLoaded', function() {
      // Listen for quick buy button clicks to store the current variant selection
      document.addEventListener('click', function(event) {
        const target = event.target;
        
        // Check if this is a quick buy button click
        if (target.matches('[aria-controls*="quick-buy"], .product-card__mobile-quick-buy-button, button[aria-controls*="quick-buy"]')) {
          const productCard = target.closest('.product-card');
          if (productCard) {
            // Find the currently selected variant in the product card
            const selectedRadio = productCard.querySelector('input[type="radio"][name*="swatch-"][data-variant-id]:checked');
            if (selectedRadio) {
              const selectedVariantId = selectedRadio.dataset.variantId;
              const quickBuyDrawer = productCard.querySelector('quick-buy-drawer');
              
              if (quickBuyDrawer && selectedVariantId) {
                // Store the selected variant ID before the drawer opens
                quickBuyDrawer.setAttribute('data-selected-variant-id', selectedVariantId);
                
                // Update the handle attribute to include the selected variant
                const currentHandle = quickBuyDrawer.getAttribute('handle');
                const baseHandle = currentHandle.split('?')[0];
                quickBuyDrawer.setAttribute('handle', `${baseHandle}?variant=${selectedVariantId}`);
                
                // Force reload the drawer content to ensure it shows the correct variant
                quickBuyDrawer._hasLoaded = false;
                
                console.log('BK-Media: Stored variant ID and forced reload before quick buy drawer opens:', selectedVariantId);
              }
            }
          }
        }
      });
    });
  });
})();

// ========================================
// FREE SHIPPING BAR FIX FOR DISCOUNT CODES
// ========================================

// Fix for free shipping bar showing NaN when discount codes are applied
document.addEventListener('DOMContentLoaded', function() {
  // Initially hide free shipping bars until cart drawer is opened
  const freeShippingBars = document.querySelectorAll('free-shipping-bar');
  freeShippingBars.forEach(function(bar) {
    bar.style.display = 'none';
  });
  // Override the FreeShippingBar's _onCartChanged method to handle discount codes properly
  const originalFreeShippingBar = customElements.get('free-shipping-bar');
  if (originalFreeShippingBar) {
    const originalOnCartChanged = originalFreeShippingBar.prototype._onCartChanged;
    
    originalFreeShippingBar.prototype._onCartChanged = function(event) {
      try {
        // Get cart data from the event
        const cartData = event.detail?.cart || event.detail;
        
        if (!cartData || !cartData.items) {
          console.warn('BK-Media: No cart data found in event');
          return;
        }
        
        // Calculate price for items that require shipping
        let priceForItems = 0;
        if (Array.isArray(cartData.items)) {
          priceForItems = cartData.items
            .filter(item => item.requires_shipping)
            .reduce((sum, item) => {
              const linePrice = parseFloat(item.final_line_price) || 0;
              return sum + linePrice;
            }, 0);
        }
        
        // Calculate cart-level discounts
        let cartDiscount = 0;
        if (cartData.cart_level_discount_applications && Array.isArray(cartData.cart_level_discount_applications)) {
          cartDiscount = cartData.cart_level_discount_applications.reduce((sum, discount) => {
            const discountAmount = parseFloat(discount.total_allocated_amount) || 0;
            return sum + discountAmount;
          }, 0);
        }
        
        // Calculate final total price
        const totalPrice = priceForItems - cartDiscount;
        
        // Ensure we have a valid number
        if (!isNaN(totalPrice) && isFinite(totalPrice)) {
          this.totalPrice = totalPrice;
        } else {
          console.warn('BK-Media: Invalid total price calculated:', totalPrice);
          // Fallback: use the original method
          if (originalOnCartChanged) {
            originalOnCartChanged.call(this, event);
          }
        }
      } catch (error) {
        console.error('BK-Media: Error in free shipping bar calculation:', error);
        // Fallback: use the original method
        if (originalOnCartChanged) {
          originalOnCartChanged.call(this, event);
        }
      }
    };
  }
  
  // Additional fallback: Listen for cart updates and manually update free shipping bars
  document.addEventListener('cart:change', function(event) {
    // Find all free shipping bars and update them
    const freeShippingBars = document.querySelectorAll('free-shipping-bar');
    freeShippingBars.forEach(function(bar) {
      try {
        // Get the current cart data from the event
        const cartData = event.detail?.cart || event.detail;
        
        if (cartData && cartData.items) {
          // Calculate price for items that require shipping
          let priceForItems = 0;
          if (Array.isArray(cartData.items)) {
            priceForItems = cartData.items
              .filter(item => item.requires_shipping)
              .reduce((sum, item) => {
                const linePrice = parseFloat(item.final_line_price) || 0;
                return sum + linePrice;
              }, 0);
          }
          
          // Calculate cart-level discounts
          let cartDiscount = 0;
          if (cartData.cart_level_discount_applications && Array.isArray(cartData.cart_level_discount_applications)) {
            cartDiscount = cartData.cart_level_discount_applications.reduce((sum, discount) => {
              const discountAmount = parseFloat(discount.total_allocated_amount) || 0;
              return sum + discountAmount;
            }, 0);
          }
          
          // Calculate final total price
          const totalPrice = priceForItems - cartDiscount;
          
          // Update the free shipping bar if we have a valid total
          if (!isNaN(totalPrice) && isFinite(totalPrice)) {
            bar.setAttribute('total-price', totalPrice);
          }
        }
      } catch (error) {
        console.error('BK-Media: Error updating free shipping bar:', error);
      }
    });
  });
  
  // Additional fix: Recalculate free shipping bars when cart drawer opens
  document.addEventListener('dialog:after-show', function(event) {
    if (event.target.id === 'cart-drawer') {
      // Show free shipping bars when cart drawer opens
      const freeShippingBars = document.querySelectorAll('free-shipping-bar');
      freeShippingBars.forEach(function(bar) {
        bar.style.display = 'grid';
      });
      
      // Small delay to ensure cart data is loaded
      setTimeout(function() {
        freeShippingBars.forEach(function(bar) {
          // Trigger a manual update by dispatching a cart change event
          const cartChangeEvent = new CustomEvent('cart:change', {
            detail: {
              cart: window.cart || {}
            }
          });
          bar._onCartChanged(cartChangeEvent);
        });
      }, 100);
    }
  });
  
  // Hide free shipping bar when cart drawer is closed
  document.addEventListener('dialog:after-hide', function(event) {
    if (event.target.id === 'cart-drawer') {
      const freeShippingBars = document.querySelectorAll('free-shipping-bar');
      freeShippingBars.forEach(function(bar) {
        bar.style.display = 'none';
      });
    }
  });
});

// Hide stock info when product is sold out
function hideStockInfoWhenSoldOut() {
  // Check buy buttons stock info
  const buyButtonsStockInfo = document.getElementById('buy-buttons-stock-info');
  if (buyButtonsStockInfo) {
    // Check if product is available by looking at button state and text
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const addToCartButton = productForm.querySelector('button[type="submit"]');
      if (addToCartButton) {
        const buttonText = addToCartButton.textContent.trim().toLowerCase();
        const isSoldOut = addToCartButton.disabled || 
                         buttonText.includes('sold out') || 
                         buttonText.includes('ausverkauft') ||
                         buttonText.includes('nicht verfügbar');
        if (isSoldOut) {
          buyButtonsStockInfo.classList.add("no-stock");
        } else {
          buyButtonsStockInfo.classList.remove("no-stock");
        }
      }
    }
  }
  
  // Check quantity discount stock info
  const quantityStockInfo = document.getElementById('boomers-stock-info');
  if (quantityStockInfo) {
    // Check if product is available by looking at button state and text
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const addToCartButton = productForm.querySelector('button[type="submit"]');
      if (addToCartButton) {
        const buttonText = addToCartButton.textContent.trim().toLowerCase();
        const isSoldOut = addToCartButton.disabled || 
                         buttonText.includes('sold out') || 
                         buttonText.includes('ausverkauft') ||
                         buttonText.includes('nicht verfügbar');
        
        if (isSoldOut) {
          quantityStockInfo.style.display = 'none';
        } else {
          quantityStockInfo.style.display = 'flex';
        }
      }
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', hideStockInfoWhenSoldOut);

// Run when variant changes
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name="id"], select[name="id"]')) {
    setTimeout(hideStockInfoWhenSoldOut, 100);
  }
});

// Run when section loads (for dynamic content)
document.addEventListener('shopify:section:load', hideStockInfoWhenSoldOut);

// ========================================
// CUSTOM SCROLL JUMP FUNCTIONALITY
// ========================================

// Custom scroll jump functionality for related products
function initScrollJumpFunctionality() {
  // Find all scroll-carousel elements with data-scroll-jump attribute
  const scrollCarousels = document.querySelectorAll('scroll-carousel[data-scroll-jump]');
  
  console.log('BK-Media: Found scroll carousels with jump data:', scrollCarousels.length);
  
  scrollCarousels.forEach(function(carousel) {
    // Skip if already initialized to prevent overriding working carousels
    if (carousel._jumpInitialized) {
      console.log('BK-Media: Carousel already initialized, skipping');
      return;
    }
    
    const jumpAmount = parseInt(carousel.getAttribute('data-scroll-jump')) || 1;
    console.log('BK-Media: Setting up scroll jump for carousel with amount:', jumpAmount);
    
    // Store the jump amount as a property
    carousel._jumpAmount = jumpAmount;
    carousel._jumpInitialized = true;
    
    // We don't need to override methods anymore since we're handling everything in event handlers
    
    // Remove existing event listeners to prevent duplicates
    carousel.removeEventListener('control:next', carousel._jumpNextHandler);
    carousel.removeEventListener('control:prev', carousel._jumpPrevHandler);
    
    // Create new event handlers that bypass the theme's default behavior
    carousel._jumpNextHandler = function(event) {
      if (this._jumpInitialized) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Use our custom jump logic directly instead of calling this.next()
        const currentIndex = this.selectedIndex;
        const maxIndex = this.items.length - 1;
        let newIndex = currentIndex + this._jumpAmount;
        
        if (newIndex >= maxIndex) {
          newIndex = maxIndex;
        }
        
        console.log('BK-Media: Direct jump from', currentIndex, 'to', newIndex, '(jump amount:', this._jumpAmount, ')');
        this.select(newIndex, { direction: "next", animate: true });
      }
    };
    
    carousel._jumpPrevHandler = function(event) {
      if (this._jumpInitialized) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Use our custom jump logic directly instead of calling this.previous()
        const currentIndex = this.selectedIndex;
        const newIndex = Math.max(currentIndex - this._jumpAmount, 0);
        
        console.log('BK-Media: Direct jump from', currentIndex, 'to', newIndex, '(jump amount:', this._jumpAmount, ')');
        this.select(newIndex, { direction: "previous", animate: true });
      }
    };
    
    // Add event listeners
    carousel.addEventListener('control:next', carousel._jumpNextHandler);
    carousel.addEventListener('control:prev', carousel._jumpPrevHandler);
  });
}

// Initialize scroll jump functionality on page load
document.addEventListener('DOMContentLoaded', function() {
  // Add a small delay to ensure custom elements are fully loaded
  setTimeout(initScrollJumpFunctionality, 100);
});

// Re-initialize when sections are loaded dynamically
document.addEventListener('shopify:section:load', function() {
  // Add a small delay to ensure custom elements are fully loaded
  setTimeout(initScrollJumpFunctionality, 100);
});

// Also try to initialize when custom elements are defined
document.addEventListener('DOMContentLoaded', function() {
  // Wait for custom elements to be defined
  if (customElements.get('scroll-carousel')) {
    setTimeout(initScrollJumpFunctionality, 200);
  } else {
    // If not defined yet, wait a bit more
    setTimeout(function() {
      if (customElements.get('scroll-carousel')) {
        initScrollJumpFunctionality();
      }
    }, 500);
  }
});

// Use MutationObserver to watch for scroll-carousel elements being added
const observer = new MutationObserver(function(mutations) {
  let shouldReinit = false;
  mutations.forEach(function(mutation) {
    // Only reinitialize if new scroll-carousel elements are added, not for attribute changes
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'SCROLL-CAROUSEL' && node.hasAttribute('data-scroll-jump')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('scroll-carousel[data-scroll-jump]')) {
            shouldReinit = true;
          }
        }
      });
    }
  });
  
  if (shouldReinit) {
    console.log('BK-Media: New scroll-carousel with jump data detected, reinitializing...');
    setTimeout(initScrollJumpFunctionality, 100);
  }
});

// Start observing
document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Add a safeguard to prevent interference with product card variant selections
document.addEventListener('DOMContentLoaded', function() {
  // Listen for variant selection changes and ensure scroll jump functionality doesn't interfere
  document.addEventListener('change', function(event) {
    const target = event.target;
    
    // If this is a variant selection in a product card, don't reinitialize scroll jump
    if (target.matches('input[type="radio"][name*="swatch-"][data-variant-id]')) {
      const productCard = target.closest('.product-card');
      if (productCard) {
        // Skip scroll jump reinitialization for product card variant changes
        console.log('BK-Media: Product card variant selection detected, skipping scroll jump reinit');
        return;
      }
    }
  });
});


//logic for slider
window.initCartRecommendationsSlider = function(root){
  const container = root.querySelector('.cart-recommendations__list, .new-slider-container');
  const pagination = root.querySelector('.cart-recommendations__bullets');
  if (!container || !pagination) return;
  // Nur einmal pro Container initialisieren (verhindert doppelte Listener/Observer
  // nach einem Cart-Drawer-Re-Render, bei dem dieses Inline-Script nicht neu laeuft).
  if (container.__recoSliderInit) return;
  container.__recoSliderInit = true;

  const viewport = container.closest('.cart-recommendations__viewport');
  const prevBtn = root && root.querySelector('.cart-recommendations__nav--prev');
  const nextBtn = root && root.querySelector('.cart-recommendations__nav--next');

  const TOTAL_BULLETS = 3;
  let bullets = [];

  let slides, totalSlides;

  // ==========================================
  // 1. Mouse / Pointer Dragging Logic
  // ==========================================
  // Maus: erst ab einer Bewegungs-Schwelle wirklich ziehen (und erst dann
  // Pointer capturen), damit ein einfacher Klick auf Bild/Titel den Produktlink
  // oeffnet. Touch/Pen nutzen natives Scrollen + native Taps (nicht angefasst).
  const DRAG_THRESHOLD = 6;
  let isDragging = false;
  let pendingDrag = false;
  let moved = false;
  let startX = 0;
  let startScrollLeft = 0;

  container.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse') return;   // Touch/Pen: natives Scrollen + Tippen
    if (e.button !== 0) return;
    if (e.target.closest(".product-card__quick-buy")) return;

    pendingDrag = true;
    moved = false;
    startX = e.pageX - container.offsetLeft;
    startScrollLeft = container.scrollLeft;
  });

  container.addEventListener('pointermove', (e) => {
    if (!pendingDrag) return;

    const currentX = e.pageX - container.offsetLeft;
    const walk = (currentX - startX) * 1.2; // Speed multiplier (1.2x)

    if (!isDragging) {
      if (Math.abs(walk) < DRAG_THRESHOLD) return; // noch kein echtes Ziehen
      isDragging = true;
      moved = true;
      container.classList.add('dragging');
      container.setPointerCapture(e.pointerId);
    }

    e.preventDefault();
    container.scrollLeft = startScrollLeft - walk;
  });

  const stopDragging = (e) => {
    pendingDrag = false;
    if (!isDragging) return;
    isDragging = false;
    container.classList.remove('dragging');

    if (container.hasPointerCapture && container.hasPointerCapture(e.pointerId)) {
      container.releasePointerCapture(e.pointerId);
    }
  };

  container.addEventListener('pointerup', stopDragging);
  container.addEventListener('pointercancel', stopDragging);

  // Nach echtem Ziehen (Maus) den folgenden Klick (z.B. Produktlink) unterdruecken
  container.addEventListener('click', (e) => {
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);

  // ==========================================
  // 1b. Desktop-Pfeil-Buttons (prev/next)
  // ==========================================
  function scrollByCards(dir) {
    const card = container.querySelector('.cart-recommendations__card, .new-slider-item');
    const gap = parseFloat(getComputedStyle(container).columnGap) || 10;
    const step = card ? card.getBoundingClientRect().width + gap : container.clientWidth * 0.8;
    container.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function updateNav() {
    const maxScroll = container.scrollWidth - container.clientWidth;
    const scrollable = maxScroll > 1;
    if (viewport) viewport.classList.toggle('is-scrollable', scrollable);
    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = container.scrollLeft >= maxScroll - 1;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => scrollByCards(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollByCards(1));

  // ==========================================
  // 2. Pagination Logic (X-Axis)
  // ==========================================

  // 1. Function to build or rebuild bullets dynamically
  function renderBullets() {
    // Clear existing bullets
    pagination.innerHTML = '';
    
    const slides = container.querySelectorAll('.cart-recommendations__card, .new-slider-item');
    
    // If there are no slides or the container isn't scrollable, don't show bullets
    if (slides.length <= 1 || container.scrollWidth <= container.clientWidth) {
      bullets = [];
      updateNav();
      return;
    }

    // Always create exactly 3 bullets
    for (let i = 0; i < TOTAL_BULLETS; i++) {
      const bullet = document.createElement('div');
      bullet.classList.add('cart-recommendations__bullet');
      
      // Click behavior maps to 0%, 50%, and 100% of max scroll
      bullet.addEventListener('click', () => {
        const maxScroll = container.scrollWidth - container.clientWidth;
        // Index 0 -> 0 (Top), Index 1 -> 0.5 (Middle), Index 2 -> 1 (Bottom)
        const targetScroll = maxScroll * (i / (TOTAL_BULLETS - 1));
        container.scrollTo({ left: targetScroll, behavior: 'smooth' });
      });

      pagination.appendChild(bullet);
    }

    // Update bullet references
    bullets = pagination.querySelectorAll('.cart-recommendations__bullet');
    
    // Set the correct active bullet immediately based on current scroll
    updateActiveBullet();
    updateNav();
  }

  // 2. Function to update the active class on scroll
  function updateActiveBullet() {
    if (!bullets || bullets.length === 0) return;

    const maxScroll = container.scrollWidth - container.clientWidth;
    if (maxScroll <= 0) return;

    const scrollRatio = container.scrollLeft / maxScroll;
    
    // Divide the scroll area into thirds to assign the active bullet
    // 0.00 to 0.33 -> Index 0
    // 0.34 to 0.66 -> Index 1
    // 0.67 to 1.00 -> Index 2
    const activeIndex = Math.min(
      Math.floor(scrollRatio * TOTAL_BULLETS), 
      TOTAL_BULLETS - 1
    );

    bullets.forEach((bullet, idx) => {
      bullet.classList.toggle('active', idx === activeIndex);
    });
  }

  // 3. Initialize bullets on first load
  renderBullets();

  // 4. React to scroll position
  container.addEventListener('scroll', () => { updateActiveBullet(); updateNav(); });

  // 5. Watch for dynamically added/removed slides
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Rebuild the bullets whenever a slide is added or removed
        renderBullets();
        break; // Only need to trigger once per batch of mutations
      }
    }
  });

  // Start observing the scroll container for direct child changes
  observer.observe(container, { childList: true });
};